import { Component, inject } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ArticleAttributes } from 'api/addons/models/article-attributes';

@Component({
    selector: 'app-debug-create-article-dialog',
    templateUrl: './debug-create-article-dialog.component.html',
    styleUrl: './debug-create-article-dialog.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
    ],
})
export class DebugCreateArticleDialogComponent {
    private fb = inject(FormBuilder);
    private dialogRef = inject(MatDialogRef<DebugCreateArticleDialogComponent>);

    createArticleForm: FormGroup;

    constructor() {
        this.createArticleForm = this.fb.group({
            articleNumber: ['', [Validators.required]],
            description: ['test_description', [Validators.required]],
            quantity: [1, [Validators.required, Validators.min(1)]],
            index: [0, [Validators.required, Validators.min(0)]],
            articleOrderNumber: [''],
            customerArticleNumber: [''],
            containerType: ['-', [Validators.required]],
        });
    }

    onSubmit(): void {
        if (this.createArticleForm.invalid) {
            this.createArticleForm.markAllAsTouched();
            return;
        }

        const newArticle: ArticleAttributes = {
            articleNumber: this.createArticleForm.get('articleNumber')?.value,
            description: this.createArticleForm.get('description')?.value,
            quantity: this.createArticleForm.get('quantity')?.value,
            index: this.createArticleForm.get('index')?.value,
            articleOrderNumber:
                this.createArticleForm.get('articleOrderNumber')?.value,
            customerArticleNumber: this.createArticleForm.get(
                'customerArticleNumber'
            )?.value,
            containerType: this.createArticleForm.get('containerType')?.value,
        };

        this.dialogRef.close(newArticle);
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
